import angular from 'angular';
import ngResource from 'angular-resource';
import AllDefinitionsCacheService from './all-definitions-cache.service';
import CacheService from './cache.service';
import ImageCacheService from './image-cache.service';
import SideMenuCacheService from './side-menu-cache.service';

export default angular.module('CacheModule', [ngResource])
    .service('AllDefinitionsCacheService', AllDefinitionsCacheService)
    .service('SideMenuCacheService', SideMenuCacheService)

    .factory('CacheService', CacheService)
    .factory('ImageCacheService', ImageCacheService)

    .name; // must come last
